import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, QrCode, Volume2, Globe, Layers, Users } from "lucide-react";
import { A, MERCHANT_LOGIN_URL } from "../config";
import { NAV, to } from "../data";
import { IC } from "./icons";

const ICONS = [QrCode, Volume2, Globe, Layers, Users];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [menu, setMenu] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
    setMenu(null);
  }, [pathname]);

  useEffect(() => {
    const away = (e) => {
      if (!e.target.closest(".dd")) setMenu(null);
    };
    document.addEventListener("click", away);
    return () => document.removeEventListener("click", away);
  }, []);

  return (
    <header id="hd" className={open ? "open" : ""}>
      <div className="w nav">
        <Link className="logo" to="/" aria-label="Formax Connect home">
          <img className="lgi" src={A + "logo.png"} alt="Formax Connect" width="160" height="31" />
        </Link>
        <nav className="menu" aria-label="Main">
          {NAV.map((g) => (
            <div className={"dd" + (menu === g.label ? " open" : "") + (g.items.some(([k]) => k.indexOf("http") !== 0 && to(k) === pathname) ? " cur" : "")} key={g.label} onKeyDown={(e) => e.key === "Escape" && setMenu(null)}>
              <button type="button" aria-haspopup="true" aria-expanded={menu === g.label} onClick={() => setMenu(menu === g.label ? null : g.label)}>{g.label} ▾</button>
              <div className="pane">
                <div className="pl">
                  <div className="pt">{g.label}</div>
                  {g.items.map(([k, n, d, icon, group], i) => {
                    const Icon = (icon && IC[icon]) || ICONS[i % ICONS.length];
                    const inner = (
                      <>
                        <span className="ic"><Icon size={18} /></span>
                        <span><b>{n}</b><small>{d}</small></span>
                      </>
                    );
                    const head = group && i > 0 && !g.items[i - 1][4] && <div className="pt pts" key={"h" + n}>Business</div>;
                    return k.indexOf("http") === 0 ? (
                      <a key={n} href={k} target="_blank" rel="noopener noreferrer">{inner}</a>
                    ) : (
                      <React.Fragment key={n}>
                        {head}
                        <Link to={to(k)} aria-current={to(k) === pathname ? "page" : undefined}>{inner}</Link>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
          <a className="btn mob" href={MERCHANT_LOGIN_URL} rel="noopener noreferrer">Merchant Login</a>
          <Link className="btn p mob" to="/contact-us">Get Started</Link>
        </nav>
        <div className="cta">
          <a className="btn" href={MERCHANT_LOGIN_URL} rel="noopener noreferrer">Merchant Login</a>
          <Link className="btn p" to="/contact-us">Get Started</Link>
        </div>
        <button type="button" className="btn burger" aria-label="Toggle menu" aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
    </header>
  );
}
